export function cutAddress(address: string): string {
  const partSize = 4;

  if (address.length < partSize * 2 + 3) {
    return address;
  } else {
    return address.slice(0, partSize) + "..." + address.slice(address.length - partSize);
  }
}
